import React from 'react'
import YesNoButtons from '../formGroup/YesNoButtons'
import { IAddressQuestion } from '../../interfaces/Address'

const AddressQuestion = ({
  userAddress,
  existing_address,
  register,
  disableRadio,
  error,
}: IAddressQuestion) => {
  return (
    <>
      <p className="inputLabel inputLabelRequired mb0">
        S’agit-il de votre adresse postale ?
      </p>
      <strong className="dBlock mb12 fontSizeXs">{userAddress}</strong>
      <YesNoButtons
        id="address_exist"
        name="existing_address"
        value={existing_address || ''}
        register={register({ required: true })}
        labelClassName="mb15"
        disabled={disableRadio}
        error={error}
        yesValue="1"
        noValue="0"
      />
    </>
  )
}

export default AddressQuestion
